export const skillItemStyles = {
  display: "flex",
  justifyContent: "flex-center",
  flexDirection: "row",
  alignItems: "center",
};
export const skillsItemIconStyle = {
  height: "1rem",
  margin: "0 0.5rem",
};

export const skillsItemTextStyle = {
  color: "#004A55",
};
export const darkSKillsItemTextStyle = {
  color: "white",
};
